<!--suppress ALL -->

<template>
  <div>
    <el-upload :action="this.$imageUploadPath"
               ref="upload" list-type="picture-card" :on-preview="handlePictureCardPreview"
               :on-remove="handleRemove" :before-upload="handleBeforeUpload" :limit="1"
               :on-success="uploadSuccess"
               accept="image/*"
               :class="{disabled:uploadDisabled}">
      <i style="" class="el-icon-plus"></i>
    </el-upload>
    <img v-if="pickImage" :src="pickImage" width="150px" height="150px"/>
    <el-button v-if="pickImage" type="text" size="small" @click="deletePickImage">删除</el-button>
    <el-dialog top="10px" title="图片预览" :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="imageUrl" alt="">
      <div slot="footer"></div>
    </el-dialog>
    <div>
      <el-button type="text" size="small" @click="aiCreate">通过AI生成</el-button>
    </div>
    <image-generate ref="imageGenerate" @refresh="imageReturn"></image-generate>
  </div>
</template>


<script>

import ImageGenerate from "@/components/ImageGenerate"
import VideoAvatarClone from "../pages/aigc/video_avatar_clone";

export default {
  name: 'ImageUpload',
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      dialogVisible: false,
      uploadDisabled: false,
      pickImage: ""
    }
  },
  components: {ImageGenerate},

  methods: {
    handlePictureCardPreview(file) {
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.imageUrl = ''
      this.uploadDisabled = false;
    },

    handleBeforeUpload(file) {
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      // 判断是否符合文件大小的限制需求
      const isLt2M = file.size / 1024 / 1024 < 10
      // 判断是否符合文件类型需求
      let accept = 'jpg/png/gif/jpeg'
      const isLtType = accept.indexOf(suffix) >= 0
      if (!isLtType) {
        this.$message({
          message: `上传文件格式必须为${accept}`,
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过10M!`,
          type: 'warning'
        })
      }
      return isLt2M && isLtType
    },


    uploadSuccess(A, file, fileList) {
      this.imageUrl = file.response.data.url;
      this.$emit('upload-success', file.response.data.url);
      this.uploadDisabled = true;
      //this.$refs.upload.clearFiles();
    },

    aiCreate() {
      this.$refs.imageGenerate.show("")
    },
    imageReturn(e) {
      console.log(e)
      this.pickImage = e;
      this.$emit('upload-success', e);
      this.uploadDisabled = true;
    },
    deletePickImage(){
      this.pickImage = ''
      this.uploadDisabled = false;
    }
  }

}
</script>
<style scoped >
@import '../assets/global.css';
</style>
